// extracted by mini-css-extract-plugin
module.exports = {"sessionDetails":"SessionDetails_sessionDetails__1z6aR"};